import { GAME_OPTIONS, type GameType } from '@tv-casino/shared';
import styles from './GamePicker.module.css';

interface GamePickerProps {
  gameType: GameType;
  /** A game picked mid-hand, waiting for the hand to end. */
  pending?: GameType | null;
  locked: boolean;
  onSelect: (game: GameType) => void;
}

const pickerLabel = (id: GameType, label: string): string =>
  id === 'holdem' ? "Texas Hold'em" : label;

/**
 * Switch the table between the games. Mid-hand the pick waits for the hand to
 * end; the game in play takes a waiting pick back.
 */
export function GamePicker({ gameType, pending = null, locked, onSelect }: GamePickerProps) {
  return (
    <div className={styles.row}>
      {GAME_OPTIONS.map(({ id, label }) => (
        <button
          key={id}
          type="button"
          className={`${styles.button} ${gameType === id ? styles.active : ''} ${pending === id ? styles.pending : ''}`}
          disabled={locked || pending === id || (gameType === id && pending === null)}
          onClick={() => onSelect(id)}
        >
          {pickerLabel(id, label)}
        </button>
      ))}
    </div>
  );
}
